import { ECountry } from 'App/i18n/i18n.types';

import { CarrierResponse } from 'domains/configurations/pages/carrier/type/carrier-response-dto';

import {
  DeliveryOrderCreationType,
  DeliveryOrderDeliveryType,
  DeliveryOrderFreightType
} from '../types/commons';

export const NUVEM_ENVIO_NAME = 'Nuvem Envio';
export const ENVIO_NUBE_NAME = 'Envío Nube';

export const CarrierJadLog = 'jadlog';
export const CarrierLoggi = 'loggi';
export const CarrierMandae = 'mandae';
export const CarrierCorreios = 'correios';
export const CarrierCorreoArgentino = 'correo-argentino';
export const CarrierAndreani = 'andreani';
export const CarrierEnvia = 'envia';
export const CarrierEPick = 'e-pick';

export const NECorreioSedex = 'ne-correios-sedex';
export const NECorreioPAC = 'ne-correios-pac';
export const NECorreioMini = 'ne-correios-mini';
export const NEMandaeEconomico = 'ne-mandae-economico';
export const NEMandaeExpress = 'ne-mandae-express';
export const NELoggiExpress = 'ne-loggi-express';
export const NELoggiEconomic = 'ne-loggi-economic';
export const NELoggiEconomicCollect = 'ne-loggi-economic-collect';

export const NEAndreaniDomicilio = 'ne-andreani-domicilio';
export const NEAndreaniSucursal = 'ne-andreani-sucursal';

export const NECorreoArgClasicoDomicilio = 'ne-correo-arg-clasico-domicilio';
export const NECorreoArgClasicoSucursal = 'ne-correo-arg-clasico-sucursal';
export const NECorreoArgExpresoDomicilio = 'ne-correo-arg-expreso-domicilio';
export const NECorreoArgExpresoSucursal = 'ne-correo-arg-expreso-sucursal';

export const NEJadLog = 'ne-jadlog-package';
export const NEJadLogCom = 'ne-jadlog-com';

export const NEEnviaEstafetaGround = 'ne-envia-estafeta-ground';
export const NEEnviaEstafetaExpress = 'ne-envia-estafeta-express';
export const NEEnviaEstafetaLocal = 'ne-envia-estafeta-local';
export const NEEnviaFedexGround = 'ne-envia-fedex-ground';
export const NEEnviaFedexExpress = 'ne-envia-fedex-express';
export const NEEnviaDhlGround = 'ne-envia-dhl-ground';
export const NEEnviaDhlExpress = 'ne-envia-dhl-express';
export const NEEnviaNoventa9MinutosLocalNextDay =
  'ne-envia-noventa9Minutos-local-next-day';
export const NEEnviaNoventa9MinutosNextDay =
  'ne-envia-noventa9Minutos-next-day';
export const NEEnviaFedexInternationalGround = 'ne-envia-fedex-int-ground';
export const NEEnviaDhlInternationalExpress = 'ne-envia-dhl-int-express';

export const NEEPickDomicilio = 'ne-e-pick-domicilio';
export const NEEPickOcaDomicilio = 'ne-e-pick-oca-domicilio';

export const CarrierMagalog = 'magalog';
export const NEMagalogCollect = 'ne-magalog-collect';

export const CarrierJet = 'jet';
export const NEJetExpress = 'ne-jet-express';
export const NEJetEconomic = 'ne-jet-economic';

export const CarrierIFood = 'ifood';
export const NEIFoodStandard = 'ne-ifood-standard';

export const CollectDeliveryOptions: string[] = [NEIFoodStandard];

export const isCollectDeliveryOption = (code?: string): boolean =>
  !!code && CollectDeliveryOptions.includes(code);

const handleCarrierName = (carrierName: string): string => {
  switch (carrierName) {
    case CarrierJadLog:
      return 'Jadlog';
    case CarrierLoggi:
      return 'Loggi';
    case CarrierMandae:
      return 'Nuvem Envio';
    case CarrierMagalog:
      return 'Nuvem Envio Coleta';
    case CarrierJet:
      return 'Nuvem Envio Coleta';
    case CarrierCorreios:
      return 'Correios';
    case CarrierIFood:
      return 'iFood';
    default:
      return carrierName;
  }
};

const handleDeliveryOptionName = (code: string): string => {
  switch (code) {
    case NECorreioSedex:
      return 'Correios Sedex';
    case NECorreioPAC:
      return 'Correios PAC';
    case NECorreioMini:
      return 'Correios Mini';
    case NEMandaeEconomico:
      return 'Nuvem Envio Econômico';
    case NEMandaeExpress:
      return 'Nuvem Envio Rápido';
    case NELoggiExpress:
      return 'Loggi Express';
    case NELoggiEconomic:
      return 'Loggi Pontos';
    case NELoggiEconomicCollect:
      return 'Loggi Coleta';
    case NECorreoArgClasicoDomicilio:
      return 'Correo Argentino Clásico a domicilio';
    case NECorreoArgClasicoSucursal:
      return 'Correo Argentino Clásico a sucursal';
    case NECorreoArgExpresoDomicilio:
      return 'Correo Argentino Expreso a domicilio';
    case NECorreoArgExpresoSucursal:
      return 'Correo Argentino Expreso a sucursal';
    case NEJadLog:
      return 'Jadlog Econômico';
    case NEJadLogCom:
      return 'Jadlog Rápido';
    case NEAndreaniDomicilio:
      return 'Andreani a domicilio';
    case NEAndreaniSucursal:
      return 'Andreani a sucursal';
    case NEEnviaEstafetaGround:
      return 'Estafeta Terrestre';
    case NEEnviaEstafetaExpress:
      return 'Estafeta Express';
    case NEEnviaEstafetaLocal:
      return 'Estafeta Metropolitano';
    case NEEnviaFedexGround:
      return 'FedEx Nacional Económico';
    case NEEnviaFedexExpress:
      return 'FedEx Nacional Día Siguiente';
    case NEEnviaDhlGround:
      return 'DHL Nacional Económico';
    case NEEnviaDhlExpress:
      return 'DHL Nacional Día Siguiente';
    case NEEnviaNoventa9MinutosLocalNextDay:
      return '99Minutos Local Día Siguiente';
    case NEEnviaNoventa9MinutosNextDay:
      return '99Minutos Nacional Estándar';
    case NEEnviaFedexInternationalGround:
      return 'FedEx Internacional';
    case NEEnviaDhlInternationalExpress:
      return 'DHL Internacional';
    case NEEPickDomicilio:
      return 'Entrega a domicilio';
    case NEEPickOcaDomicilio:
      return 'OCA a domicilio';
    case NEMagalogCollect:
      return 'Nuvem Envio Coleta';
    case NEJetExpress:
      return 'Nuvem Envio Coleta';
    case NEJetEconomic:
      return 'J&T Econômico';
    case NEIFoodStandard:
      return 'iFood - Entrega mesmo dia';
    default:
      return code;
  }
};

const handleDeliveryOptionDisplayName = (
  code: string,
  country: ECountry
): string => {
  const name = handleDeliveryOptionName(code);

  if (country !== ECountry.BRAZIL || name.startsWith(NUVEM_ENVIO_NAME)) {
    return name;
  }

  return `${NUVEM_ENVIO_NAME} ${name}`;
};

const handleShortDeliveryOptionName = (code: string): string => {
  switch (code) {
    case NECorreioSedex:
      return 'Sedex';
    case NECorreioPAC:
      return 'PAC';
    case NECorreioMini:
      return 'Mini';
    case NEMandaeEconomico:
      return 'Econômico';
    case NEMandaeExpress:
      return 'Rápido';
    case NELoggiExpress:
      return 'Rápido';
    case NELoggiEconomic:
      return 'Pontos';
    case NELoggiEconomicCollect:
      return 'Coleta';
    case NEJadLog:
      return 'Econômico';
    case NEJadLogCom:
      return 'Rápido';
    case NEMagalogCollect:
      return 'Coleta';
    case NEJetExpress:
      return 'Coleta';
    case NEJetEconomic:
      return 'Econômico';
    case NEIFoodStandard:
      return 'Entrega mesmo dia';
    default:
      return code;
  }
};

const handleDeliveryType = (
  creationType: DeliveryOrderCreationType,
  deliveryType: DeliveryOrderDeliveryType,
  freightType?: DeliveryOrderFreightType
) => {
  if (creationType === 'sale') {
    if (freightType) {
      if (
        freightType === DeliveryOrderFreightType.NuvemEnvio ||
        freightType === DeliveryOrderFreightType.NativeCorreios ||
        freightType === DeliveryOrderFreightType.Fallback
      ) {
        return 'online-store';
      }

      return freightType;
    }

    return 'online-store';
  }

  if (creationType === 'detached') {
    return deliveryType;
  }
};

const enabledCancellationCarrier = {
  [ECountry.BRAZIL]: [
    NECorreioSedex,
    NECorreioPAC,
    NECorreioMini,
    NEJadLog,
    NEJadLogCom
  ],
  [ECountry.ARGENTINA]: [
    NEEPickDomicilio,
    NEEPickOcaDomicilio,
    NEAndreaniDomicilio,
    NEAndreaniSucursal,
    NECorreoArgClasicoDomicilio,
    NECorreoArgClasicoSucursal,
    NECorreoArgExpresoDomicilio,
    NECorreoArgExpresoSucursal
  ],
  [ECountry.MEXICO]: [
    NEEnviaEstafetaGround,
    NEEnviaEstafetaExpress,
    NEEnviaEstafetaLocal,
    NEEnviaFedexGround,
    NEEnviaFedexExpress,
    NEEnviaDhlGround,
    NEEnviaDhlExpress,
    NEEnviaNoventa9MinutosLocalNextDay,
    NEEnviaNoventa9MinutosNextDay,
    NEEnviaFedexInternationalGround,
    NEEnviaDhlInternationalExpress
  ]
};

const hasActiveDeliveryOptions = (carriers: CarrierResponse[]) =>
  carriers.some((carrier) => carrier.modalities.some(({ active }) => active));

export {
  handleDeliveryOptionName,
  handleDeliveryOptionDisplayName,
  handleDeliveryType,
  enabledCancellationCarrier,
  handleShortDeliveryOptionName,
  handleCarrierName,
  hasActiveDeliveryOptions
};
